<template>
  <vue-bottom-sheet @closed="onClosed" ref="myBottomSheet" class="bottom-sheet">
    <slot></slot>
  </vue-bottom-sheet>
</template>

<script setup lang="ts">
  import { eventBus } from "@/helpers/eventBus";
  import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
  import "@webzlodimir/vue-bottom-sheet/dist/style.css";
  import { nextTick, onMounted, onUnmounted, ref } from "vue";

  const myBottomSheet = ref<InstanceType<typeof VueBottomSheet>>();

  const emit = defineEmits(["onClose"]);

  const open = () => {
    myBottomSheet.value?.open();
  };

  const close = () => {
    myBottomSheet.value?.close();
  };

  const onClosed = () => {
    emit("onClose");
  };

  defineExpose({ open, close });

  const updateCart = async () => {
    nextTick(() => {
      if (myBottomSheet.value) {
        const bottomSheet = document?.querySelector(".bottom-sheet");
        if (bottomSheet) {
          const bottomSheetMain = bottomSheet?.querySelector(
            ".bottom-sheet__main"
          ) as HTMLElement;
          const bottomSheetContent = bottomSheet?.querySelector(
            ".bottom-sheet__content"
          ) as HTMLElement;

          if (bottomSheetContent) {
            bottomSheetContent.style.height = `${
              bottomSheetMain.scrollHeight + 36
            }px`;
          }
        }
      }
    });
  };

  eventBus.on("cart-updated", updateCart);

  onMounted(() => {
    window.addEventListener("storage", updateCart);
  });

  onUnmounted(() => {
    window.removeEventListener("storage", updateCart);
  });
</script>

<style lang="scss">
  .bottom-sheet {
    .bottom-sheet__draggable-thumb {
      background: $darkGray;
    }
  }
</style>
